import React from 'react'
import MainLayout from '@layouts/main-layout'
import Head from '@modules/common/components/head'
import WarrantyPartners from '@components/warranty-partners'

const WarrantyPartnersPage = () => {
  return (
    <>
      <WarrantyPartners />
    </>
  )
}

WarrantyPartnersPage.getLayout = (page: React.ReactElement) => {
  return (
    <MainLayout>
      <Head />
      {page}
    </MainLayout>
  )
}

export default WarrantyPartnersPage
